import { Navigate, Route, Routes } from 'react-router';

import { AppShell } from './components/AppShell.js';
import { useAuthBootstrap } from './hooks/useAuth.js';
import { Agenda } from './pages/Agenda.js';
import { Carteira } from './pages/Carteira.js';
import { Dashboard } from './pages/Dashboard.js';
import { Inbox } from './pages/Inbox.js';
import { Kanban } from './pages/Kanban.js';
import { Login } from './pages/Login.js';
import { MagicLinkVerify } from './pages/MagicLinkVerify.js';
import { MatterDetail } from './pages/MatterDetail.js';
import { Matters } from './pages/Matters.js';
import { Perfil } from './pages/Perfil.js';
import { Risco } from './pages/Risco.js';
import { SelectTenant } from './pages/SelectTenant.js';
import { TwoFactorSetup } from './pages/TwoFactorSetup.js';
import { TwoFactorVerify } from './pages/TwoFactorVerify.js';
import { useAuthStore } from './stores/auth.js';

function ProtectedRoutes(): JSX.Element {
  const { token, currentTenantId } = useAuthStore();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (!currentTenantId) {
    return <Navigate to="/select-tenant" replace />;
  }
  return <AppShell />;
}

export function App(): JSX.Element {
  useAuthBootstrap();
  return (
    <Routes>
      {/* ── Auth flow ───────────────────────────────────────────────── */}
      <Route path="/login" element={<Login />} />
      <Route path="/auth/verify" element={<MagicLinkVerify />} />
      <Route path="/auth/2fa/setup" element={<TwoFactorSetup />} />
      <Route path="/auth/2fa/verify" element={<TwoFactorVerify />} />
      <Route path="/select-tenant" element={<SelectTenant />} />

      {/* ── App protegido ───────────────────────────────────────────── */}
      <Route element={<ProtectedRoutes />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/kanban" element={<Kanban />} />
        <Route path="/carteira" element={<Carteira />} />
        <Route path="/risco" element={<Risco />} />
        <Route path="/processos" element={<Carteira />} />
        <Route path="/matters" element={<Matters />} />
        <Route path="/matters/:id" element={<MatterDetail />} />
        <Route path="/perfil" element={<Perfil />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
